import styled from 'styled-components'

import ok from '../../../assets/login/ok.svg'
import notok from '../../../assets/login/notok.svg'

export const Container = styled.div`
  position: absolute;
  top: 10%;
  left: 17.5%;
  width: 65%;
  max-height: 80%;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.32);
  overflow: auto;
  font-family: 'Roboto Slab', sans-serif;

  * {
    padding: 0;
    margin: 0;
  }

  .p-inputtext {
    display: block;
    position: relative;
    padding: 10px;

    left: 0%;
    width: 100%;
    height: 40px;

    text-align: left;
    background-color: #f1f1f2;

    border: 0;
    border-radius: 5px;
    font-size: 15px;
  }

  .p-password {
    left: 0%;
  }

  .p-inputwrapper {
    left: 30%;
    width: 65.2%;
  }

  .inactive {
    color: #777;
  }

  .ok {
    background-image: url(${ok});
  }

  .notok {
    background-image: url(${notok});
  }
`

export const Title = styled.div`
  display: flex;
  position: relative;
  width: 100%;
  height: 20px;
  padding: 8px 0 24px 0;
`

export const Logo = styled.img`
  position: relative;
  left: 50%;
  transform: translate(-50%, 0);
  margin: 21px 0 12px 0;

  /* RESPONSIVIDADE */

  /* laptop */
  @media (min-width: 1200px) {
    width: 140px;
  }

  /* laptop menor */
  @media (max-width: 1200px) {
    width: 120px;
  }

  /* tablets na horizontal */
  @media (max-width: 992px) {
    width: 100px;
  }

  /* tablets na vertical/celulares grandes */
  @media (max-width: 768px) {
    width: 90px;
    margin-top: 10px;
  }

  /* celulares pequenos */
  @media (max-width: 600px) {
    width: 80px;
    margin-top: 10px;
  }
`

export const MainText = styled.h1`
  position: absolute;
  left: 15%;

  /* RESPONSIVIDADE */

  /* laptop */
  @media (min-width: 1200px) {
    font-size: 18px;
  }

  /* laptop menor */
  @media (max-width: 1200px) {
    font-size: 16px;
  }

  /* tablets na horizontal */
  @media (max-width: 992px) {
    font-size: 14px;
  }

  /* tablets na vertical/celulares grandes */
  @media (max-width: 768px) {
    font-size: 14px;
  }

  /* celulares pequenos */
  @media (max-width: 600px) {
    font-size: 11px;
  }
`

export const ReturnButton = styled.div`
  display: flex;
  position: absolute;
  justify-content: center;
  align-items: center;
  left: 7%;

  width: 20px;
  height: 20px;

  :hover {
    background-color: #edebeb;
    cursor: pointer;
  }
`

export const FullLabel = styled.label`
  display: block;
  position: relative;
  left: 15%;
  width: 85%;
  padding: 6px 0 6px 0;

  /* RESPONSIVIDADE */

  /* laptop */
  @media (min-width: 1200px) {
    font-size: 14px;
  }

  /* laptop menor */
  @media (max-width: 1200px) {
    font-size: 13px;
  }

  /* tablets na horizontal */
  @media (max-width: 992px) {
    font-size: 12px;
  }

  /* tablets na  vertical/celulares grandes */
  @media (max-width: 768px) {
    font-size: 11px;
  }

  /* celulares pequenos */
  @media (max-width: 600px) {
    font-size: 9px;
  }
`

export const FullInput = styled.input`
  position: relative;
  display: block;
  left: 15%;
  padding: 10px;

  width: 70%;
  height: 15px;

  margin: 6px 0 6px 0;
  text-align: left;
  background-color: #f1f1f2;

  border: 0;
  border-radius: 5px;
  font-size: 15px;

  /* RESPONSIVIDADE */

  /* laptop */
  @media (min-width: 1200px) {
    font-size: 14px;
  }

  /* laptop menor */
  @media (max-width: 1200px) {
    font-size: 13px;
  }

  /* tablets na horizontal */
  @media (max-width: 992px) {
    font-size: 12px;
  }

  /* tablets na  vertical/celulares grandes */
  @media (max-width: 768px) {
    font-size: 11px;
  }

  /* celulares pequenos */
  @media (max-width: 600px) {
    font-size: 9px;
  }
`

export const DoubleInputDiv = styled.div`
  display: flex;
  position: relative;
  width: 100%;
  height: 80px;
  margin: 6px 0 6px 0;
`

export const HalfDiv = styled.div`
  display: block;
  position: relative;
  width: 50%;
  height: 80px;
  margin: 6px 0 6px 0;

  .p-inputtext{
    height: 15px;
  }
`

export const LeftLabel = styled.label`
  display: block;
  position: relative;
  left: 30%;
  width: 50%;
  padding: 6px 0 6px 0;

  /* RESPONSIVIDADE */

  /* laptop */
  @media (min-width: 1200px) {
    font-size: 14px;
  }

  /* laptop menor */
  @media (max-width: 1200px) {
    font-size: 13px;
  }

  /* tablets na horizontal */
  @media (max-width: 992px) {
    font-size: 12px;
  }

  /* tablets na  vertical/celulares grandes */
  @media (max-width: 768px) {
    font-size: 11px;
  }

  /* celulares pequenos */
  @media (max-width: 600px) {
    font-size: 9px;
  }
`

export const HalfInputLeft = styled.input`
  display: block;
  position: relative;
  padding: 10px;

  left: 30%;
  width: 65%;
  height: 15px;

  text-align: left;
  background-color: #f1f1f2;

  border: 0;
  border-radius: 5px;
  font-size: 15px;

  /* RESPONSIVIDADE */

  /* laptop */
  @media (min-width: 1200px) {
    font-size: 14px;
  }

  /* laptop menor */
  @media (max-width: 1200px) {
    font-size: 13px;
  }

  /* tablets na horizontal */
  @media (max-width: 992px) {
    font-size: 12px;
  }

  /* tablets na  vertical/celulares grandes */
  @media (max-width: 768px) {
    font-size: 11px;
  }

  /* celulares pequenos */
  @media (max-width: 600px) {
    font-size: 9px;
  }
`

export const RightLabel = styled.label`
  display: block;
  position: relative;
  left: 5%;
  width: 90%;
  padding: 6px 0 6px 0;

  /* RESPONSIVIDADE */

  /* laptop */
  @media (min-width: 1200px) {
    font-size: 14px;
  }

  /* laptop menor */
  @media (max-width: 1200px) {
    font-size: 13px;
  }

  /* tablets na horizontal */
  @media (max-width: 992px) {
    font-size: 12px;
  }

  /* tablets na  vertical/celulares grandes */
  @media (max-width: 768px) {
    font-size: 11px;
  }

  /* celulares pequenos */
  @media (max-width: 600px) {
    font-size: 9px;
  }
`

export const HalfInputRight = styled.input`
  display: block;
  position: relative;
  padding: 10px;

  left: 5%;
  width: 65%;
  height: 15px;

  text-align: left;
  background-color: #f1f1f2;

  border: 0;
  border-radius: 5px;
  font-size: 15px;

  /* RESPONSIVIDADE */

  /* laptop */
  @media (min-width: 1200px) {
    font-size: 14px;
  }

  /* laptop menor */
  @media (max-width: 1200px) {
    font-size: 13px;
  }

  /* tablets na horizontal */
  @media (max-width: 992px) {
    font-size: 12px;
  }

  /* tablets na  vertical/celulares grandes */
  @media (max-width: 768px) {
    font-size: 11px;
  }

  /* celulares pequenos */
  @media (max-width: 600px) {
    font-size: 9px;
  }
`

export const InputButton = styled.input`
  position: relative;
  left: 30%;
  width: 40%;
  height: 40px;
  margin: 14px 0 25px 0;

  border: 0;
  border-radius: 5px;

  padding: 10px;
  text-align: center;
  background-color: #6ec1e4;
  color: white;

  :hover {
    border: 1px black solid;
    cursor: pointer;
  }

  :active {
    background-color: #1f9dd4;
  }

  :disabled {
    background-color: #ccc;
    pointer-events: none;
  }

  /* RESPONSIVIDADE */

  /* laptop */
  @media (min-width: 1200px) {
    font-size: 14px;
  }

  /* laptop menor */
  @media (max-width: 1200px) {
    font-size: 13px;
  }

  /* tablets na horizontal */
  @media (max-width: 992px) {
    font-size: 12px;
  }

  /* tablets na  vertical/celulares grandes */
  @media (max-width: 768px) {
    font-size: 11px;
  }

  /* celulares pequenos */
  @media (max-width: 600px) {
    font-size: 9px;
  }
`

export const Condition = styled.label`
  display: flex;
  position: relative;
  left: 5%;
  width: 90%;
  padding: 6px 0 6px 0;

  /* RESPONSIVIDADE */

  /* laptop */
  @media (min-width: 1200px) {
    font-size: 11px;
  }

  /* laptop menor */
  @media (max-width: 1200px) {
    font-size: 10px;
  }

  /* tablets na horizontal */
  @media (max-width: 992px) {
    font-size: 9px;
  }

  /* tablets na  vertical/celulares grandes */
  @media (max-width: 768px) {
    font-size: 8px;
  }

  /* celulares pequenos */
  @media (max-width: 600px) {
    font-size: 7px;
  }
`

export const ConditionIcon = styled.label`
  display: flex;
  justify-content: center;
  align-items: center;
  transform: translate(0, 12%);
  margin-right: 5px;
  min-width: 12px;
  min-height: 12px;
  max-width: 12px;
  max-height: 12px;

  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;

  /* RESPONSIVIDADE */

  /* laptop */
  @media (min-width: 1200px) {
    font-size: 11px;
  }

  /* laptop menor */
  @media (max-width: 1200px) {
    font-size: 10px;
  }

  /* tablets na horizontal */
  @media (max-width: 992px) {
    font-size: 9px;
  }

  /* tablets na  vertical/celulares grandes */
  @media (max-width: 768px) {
    font-size: 8px;
  }

  /* celulares pequenos */
  @media (max-width: 600px) {
    font-size: 7px;
  }
`
